import React from "react";

export default function Footer(){
  return (
    <footer className="mt-12 py-8 border-t border-gray-100 dark:border-gray-800">
      <div className="max-w-6xl mx-auto px-6 text-center text-sm text-gray-600 dark:text-gray-400">
        © {new Date().getFullYear()} FinBit — Built for students. <span className="hidden sm:inline">Privacy • Terms</span>
      </div>
    </footer>
  );
}
